import styled from '@emotion/styled'
import { useEffect, useState,useContext } from 'react'
import {FaGlobeAmericas as TopIcon} from 'react-icons/fa';
import { Button, FilterDropDown } from '../../../../ui-components';
import { apiRequest } from '../../../../api';
import { NotificationContext } from '../../../../providers/notification';
import { useSettingModal } from '../../../../hooks/Context';
import { AxiosError } from 'axios';
import BatchInviteTable from './BatchInvitesTable';
import { CircularProgress } from '@mui/material';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import styles from '../../Applicants/css/display-applicant.module.css';
import { ExNyRoute } from '../../../../utils/allRouteId';
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData} from '../../../../hooks/FetchData';



interface InductionInvites {
    ApplicantId: string;
    ApplicantName: string;
    ApplicantEmail: string;
    ApplicantPhone: string;
  }



const BatchInvites = () => {
    const [select_all,set_select_all] = useState<boolean>(false);
    const [selected_invites,set_selected_invites]= useState<any>([]);
    const [active_data,set_active_data] = useState<InductionInvites[]>([]);
    const [active_route,setActiveRoute] = useState<any>({val:ExNyRoute, name:"Examination / NYSC"});
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage ] = useState('')
    const {showNotification} = useContext(NotificationContext);
    const {setShowModal} = useSettingModal();
    const [loading,set_loading] = useState<boolean>(false);
    const [searchData, setSearchData] = useState('');

    const {isLoading: allRouteIsLoading,data: allRoutedata} = FetchAllRoutes();

    const reOrderedAllRoutes = allRoutedata ? reOrderFetchedData((allRoutedata as RouteResponse )?.Data) : []

    const allRoutes = allRouteIsLoading ? [] : reOrderedAllRoutes.map((item) => {return {name: item?.RouteName, val: item?.RouteId}})

    const applicationOpt = [
        {name:'Training',val:'1'},
        {name:"Induction",val:'2'},
    ];
      
    const submitBatchInvite = (e:any) =>{
        e.preventDefault();
        const routeId = active_route.val;
        const activity = "Induction";
        set_loading(true);
        apiRequest(`api/Activity/BatchInviteInduction?routeId=${routeId}&activity=${activity}`,"POST")
        .then(data => {
            set_loading(false);
            setShowModal(false);
            set_select_all(false);
            showNotification({
                message: data?.Message || 'Induction Invites sent successfully',
                type: 'success'
            })
        })
        .catch(error => {
            set_loading(false);
            setShowModal(false);
            showNotification({
                message: error?.response?.data?.Message || error.message,
                type: 'error'
            })
        })
    }

    useEffect(()=>{
        if(active_route && active_route.val){
            setIsLoading(true);
            apiRequest(`api/Activity/GetApplicantPendingInduction?routeId=${active_route.val || 1}&&activity=Induction`,'GET').then((data:any) =>{
                set_active_data(data.Data);
                setIsError(false);
                setIsLoading(false);
            })
            .catch((error:AxiosError) =>{
                setIsError((true));
                setErrorMessage(error?.message);
                set_active_data([]);
                setIsLoading(false);
            })

        }
    },[active_route])

    const filteredData = active_data?.filter(x => (
        Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
      ));
    

    return (
    <Wrapper>
        <div className='first-div'>
            <span>
                <TopIcon />
            </span>
        </div>
        <div className='filter-div'>
            <div>Batch Invites</div>
            <div>
                <label className={styles.searchForm} >
                    <span className={styles.sI}><SearchIcon/></span>
                    <input type="text" placeholder='Search' value={searchData} onChange={e => setSearchData(e.target.value) }/>
                    <button className={styles.rBtn} type="submit"><ReloadIcon/></button>
                </label>
                <FilterDropDown bg="#11643C" color="#fff" text="Membership Routes" options={allRoutes} onChange={setActiveRoute} replace='true' />
                <FilterDropDown text="Application Period" options={applicationOpt} />
                {/* <SelectBtn >
                    <span>Select</span>
                    <input checked={select_all} onChange={() => set_select_all(!select_all)} type="checkbox" />
                </SelectBtn> */}
            </div>
        </div>
        {
            isLoading ? (
                <CircularProgress 
                  sx={{
                    fontSize: '1rem',
                    marginInline: 'auto',
                    display: 'block',
                    marginBlock: '2rem'
                  }}
                />
            ) : isError ? (
                <StyledError>{errorMessage}</StyledError>
            ) : filteredData && filteredData?.length > 0 ?
            <BatchInviteTable data = {searchData.length > 0 ? filteredData : active_data}/>
            : <NoResult>No Results</NoResult>
        }
        <div>
            <MessageForm onSubmit={submitBatchInvite}>
                {/* <label>
                    <span>Message</span>
                    <textarea value={message} onChange={(e:any)=>set_message(e.target.value)} rows={6} placeholder='Enter Invite Message Here'></textarea>
                </label> */}
                <div>
                    <Button bg="#5BC065" border="#5BC065" style={{padding:'13px 20px'}}>
                        {!loading?'Send Invites':'Loading...'}
                    </Button>

                </div>
            </MessageForm>
        </div>
        
    </Wrapper>
  )
}

export default BatchInvites;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled('div')`
  margin-block-start: 10px;
  margin-block-end: 200px;
`

const Wrapper = styled.div`
    width:calc(100vw - 140px);
    padding:20px;
    border-radius: 10px;
    background-color:var(--white-color);
    display: grid;
    grid-template-columns: 1fr;
    padding: 48px 48px 0px;
    & > .first-div{
        display:flex;
    }
    & > .first-div > span{
        width:50px;
        height:50px;
        display: flex;
        justify-content:center;
        align-items:center;
        background-color:#FFF4DE;
        color:#FEB930;
    }
    & > .filter-div{
        display:flex;
        flex-direction:column;
        gap:10px;
        margin-top:20px;
    }
    & > .filter-div > div:first-of-type{
        font-size:18px;
        font-weight:bold;
    }
    & > .filter-div > div:nth-of-type(2){
        display:flex;
        gap:15px;
    }
    & > .table-div{
        display:flex;
        flex-direction:column;
        gap:5px;
        margin-top:10px;
    }
    & > .table-div > div{
        width:100%;
    }
    & .t-head{
        display:grid;
        grid-template-columns:repeat(4,1fr);
        background-color:#E0FAEE;
        padding:15px 10px;
    }

    
`
const PageDiv = styled.div`
    padding:10px 30px;
    display: flex;
    justify-content:flex-end;
    align-items:center;
    position:relative;
    & > div{
        position:relative;
        display: flex;
        align-items: center;
    }
    & > div > div{
        display:flex;
        gap:5px;
        flex-wrap:wrap;
        width:fit-content;
        align-items:center;
    }
    & > div > span{
        position: absolute;
        top:0px;
        cursor:pointer;
    }
    & > div > span:first-of-type{
        left:-30px;
    }
    & > div > span:last-of-type{
        right:-30px;
    }
    & > div > div > span{
        width:fit-content;
        padding:3px 5px;
        display:flex;
        justify-content:center;
        align-items:center;
        height:20px;
        border-radius:3px;
        cursor:pointer;
    }
    & > div > div > span.active{
        color:#fff;
        background-color: #11643C;
    }

`

const MessageForm = styled.form`
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: center;
    & > label{
        display: flex;
        flex-direction: column;
        gap:10px;
    }
    & > label > span{
        font-size:18px;
        font-weight: bold;
        width:fit-content;
    }
    & > label > span::after{
        content:'*';
        color:red;
        display: inline-block;
        
    }
    & textarea{
        resize: vertical;
        outline:none;
        padding:10px;
        border-radius: 6px;
        
    }
    & >div{
        width:100%;
        text-align:center;
        margin-top:20px;
    }
`